import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyChtVoP51xHLxuqhDp0jNls4kZUQBzvmK0",
    authDomain: "partyplannerone.firebaseapp.com",
    projectId: "partyplannerone",
    storageBucket: "partyplannerone.firebasestorage.app",
    messagingSenderId: "37381846507",
    appId: "1:37381846507:web:d2983daf3f713ea151d5ae",
    measurementId: "G-HHF4QQQEMQ"
  };

console.log('Firebase: Initializing app with config:', firebaseConfig);

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

console.log('Firebase: App initialized successfully');
console.log('Firebase: Auth instance:', auth);
console.log('Firebase: DB instance:', db);

export { db, auth, googleProvider };
